const history = require('history');

const { createBrowserHistory } = history;
const browserHistory = createBrowserHistory();

export default browserHistory;
